import { NavLink } from "@remix-run/react";
import { trpc } from "../../lib/trpc";
import { useTranslation } from "../i18n";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { BrandLogo } from "./brand/BrandLogo";
import { headerShell } from "./ui";
export function Header(_props: { overlay?: boolean }) {
	const { t, localizedPath } = useTranslation();
	const { data: user } = trpc.auth.me.useQuery(undefined, { retry: false, networkMode: "always" });
	return (
		<header className="site-header">
			<div className={headerShell}>
				<BrandLogo size="sm" className="shrink-0" />
				<nav className="site-nav" aria-label={t("nav.main")}>
					<a href={`${localizedPath("/")}#how-it-works`} className="ui-nav-link hidden lg:inline-flex">
						{t("nav.howItWorks")}
					</a>
					<a href={`${localizedPath("/")}#formats`} className="ui-nav-link hidden lg:inline-flex">
						{t("nav.formats")}
					</a>
					<NavLink to={localizedPath("/")} end className="ui-nav-link">
						{t("nav.upload")}
					</NavLink>
					<NavLink to={localizedPath("/mypage")} className="ui-nav-link hidden sm:inline-flex">
						{t("nav.dashboard")}
					</NavLink>
					{!user && (
						<a href="/share/auth/google" className="header-login-button">
							{t("nav.login")}
						</a>
					)}
					<LanguageSwitcher />
				</nav>
			</div>
		</header>
	);
}
